module.exports = __webpack_public_path__ + "static/media/feature-collaborative-teams.ee6db41a.png";